import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AccountCommonModule } from '@inyova/account-common';
import { DesignSystemModule } from '@inyova/design-system';
import { TranslateModule } from '@ngx-translate/core';
import { DpDatePickerModule } from 'ng2-date-picker';
import { IbanDirective, IbanPipe } from 'ngx-iban';
import { NgxPageScrollCoreModule } from 'ngx-page-scroll-core';
import { ShareButtonDirective } from 'ngx-sharebuttons';

import * as components from './components';
import * as fromDirectives from './directives';
import * as customPipes from './pipes';
import * as UIElements from './ui-elements';

@NgModule({
  imports: [
    AccountCommonModule,
    CommonModule,
    TranslateModule,
    RouterModule,
    IbanDirective,
    IbanPipe,
    NgxPageScrollCoreModule,
    FormsModule,
    ReactiveFormsModule,
    ShareButtonDirective,
    DesignSystemModule,
    DpDatePickerModule
  ],
  exports: [
    ...customPipes.pipes,
    ...fromDirectives.directives,
    ShareButtonDirective,
    ...components.components,
    ...UIElements.components,
    DesignSystemModule
  ],
  declarations: [...components.components, ...customPipes.pipes, ...fromDirectives.directives, ...UIElements.components],
  providers: [customPipes.TranslateDatePipe, customPipes.TranslateNumberPipe, customPipes.TranslatePercentPipe]
})
export class SharedModule {}
